import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AgencyDetailsResponse,
  AgencyDetailsUpdateObject,
  AgencyDetailsUpdateObjectResponse,
  AgencySettingsResponse,
  AgencySettingsUpdateRequest,
} from '../models/agency-details.models';
import { NewCategoryRequest, UpdateCategoryRequest, CategoryResponse, Category } from '../models/agency-category.models';
import { BaseApiService, aaDataResponse } from '@shared/data-access';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseAgencyDetailsService {
  constructor(protected api: BaseApiService) {}

  abstract fetchAgencyDetails(): Observable<AgencyDetailsResponse>;
  abstract fetchCategories(uid: string): Observable<aaDataResponse<CategoryResponse>>;
  abstract fetchSettings(): Observable<AgencySettingsResponse>;

  abstract editAgencyDetails(details: AgencyDetailsUpdateObject): Observable<AgencyDetailsUpdateObjectResponse>;
  abstract editPointOfContact(details: AgencyDetailsUpdateObject): Observable<AgencyDetailsUpdateObjectResponse>;
  abstract editAgencySettings(settings: AgencySettingsUpdateRequest): Observable<AgencySettingsResponse>;
  abstract addNewAgencyCategory(category: NewCategoryRequest): Observable<Category>;
  abstract editAgencyCategory(uid: string, category: UpdateCategoryRequest): Observable<Category>;
  abstract deleteAgencyCategory(uid: string): Observable<string>;
}
